// extracted by mini-css-extract-plugin
module.exports = {"Card":"style_Card__1YFVn","Marck":"style_Marck__3oaV3","Wrapper":"style_Wrapper__2gY8s","Content":"style_Content__2s6d9","Text":"style_Text__34ZES","Result":"style_Result__3Wbfq"};